<template>
  <section class="hero is-primary is-bold has-logo">
    <div class="pattern">
      <!-- Hero header: will stick at the top -->
      <div class="hero-head">
        <nav class="main-nav navbar is-fixed-top is-primary">
          <img alt="Széchenyi 2020 info" class="hero-logo" src="../../assets/img/info-block-szechenyi-2020-top-right-160px.png" />
          <div class="container">
            <div class="navbar-brand">
              <span class="navbar-burger burger left" data-target="navbarContent">
                <span></span>
                <span></span>
                <span></span>
              </span>
            </div>
            <div id="navbarContent" class="navbar-menu">
              <div class="navbar-start">
                <router-link :to="{ name: 'home' }" class="navbar-item">
                  <img src="../../assets/img/logo-efop180-logo-only-white.png" alt="EFOP 1.8.0 logo" class="logo">
                  &nbsp; Főoldal
                </router-link>
                <router-link :to="{ name: 'list-best-practice-topics' }" class="navbar-item">Jógyakorlatok</router-link>
                <router-link :to="{ name: 'trainings' }" class="navbar-item">Képzések</router-link>
                <router-link :to="{ name: 'list-covid-19s' }" class="navbar-item">COVID-19 ajánlások</router-link>
                <div class="navbar-item has-dropdown is-hoverable">
                  <a class="navbar-link">Továbbiak</a>
                  <div class="navbar-dropdown is-boxed">
                    <router-link :to="{ name: 'list-best-practices' }" class="navbar-item">Keresés</router-link>
                    <router-link :to="{ name: 'glossary' }" class="navbar-item">Fogalomtár</router-link>
                    <router-link :to="{ name: 'list-international-alerts' }" class="navbar-item">Nemzetközi alertek</router-link>
                  </div>
                </div>
                <div class="navbar-item has-dropdown is-hoverable">
                  <a class="navbar-link">A projektről</a>
                  <div class="navbar-dropdown is-boxed">
                    <router-link :to="{ name: 'project' }" class="navbar-item">Projekt információk</router-link>
                    <router-link :to="{ name: 'team' }" class="navbar-item">A Csapat</router-link>
                    <router-link :to="{ name: 'contribute' }" class="navbar-item">Jógyakorlat beküldése</router-link>
                    <hr class="navbar-divider">
                    <router-link :to="{ name: 'contact' }" class="navbar-item">Kapcsolat</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>

      </div>
      <!-- Hero content: will be in the middle -->
      <div class="hero-body">
        <div class="container has-text-centered">
          <div class="columns">
            <div class="column is-12-desktop is-9-tablet is-hidden-mobile has-text-centered">
              <h1 class="title">
                Egészségügyi Jógyakorlatok
              </h1>
              <h2 class="subtitle">
                Online Katalógusa
              </h2>
            </div>
            <div class="column is-9-mobile is-hidden-tablet">
              <h2 class="title">
                Egészségügyi Jógyakorlatok
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
  export default {
    mounted () {
      $(() => {
        $('.burger').unbind('click').click((event) => {
          /* Get burger and navbar */
          let $burger = $(event.target)
          let $navbar = $('#' + $burger.data('target'))

          /* Toggle the class on both the "navbar-burger" and the "navbar-menu" */
          $burger.toggleClass('is-active')
          $navbar.toggleClass('is-active')
        })
      })
    }
  }
</script>

<style scoped>
  .hero.is-primary .navbar {
    background-color: #60BBAB;
  }

  .pattern {
    background-image: url("../../assets/img/pattern-logo-patient-safety-grey.png");
    background-size: 85%;
  }

  .hero {
    height: 160px;
    margin-top: 50px;
  }

  .hero-body {
    text-shadow: 0 3px 5px rgba(0,0,0,.3);
  }

  .has-logo {
    position: relative;
  }

  .hero-logo {
    position: absolute;
    right: 0;
    object-fit: cover;
    object-position: center center;
    height: 180px;
    z-index: 999;
  }

  .navbar-burger.left {
    margin-right: auto;
    margin-left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/General/Navbar.vue